import type { Components } from '@mui/material/styles';

export default function MUIStepLabel(): Components['MuiStepLabel'] {
  return {};
}
